<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar/>
    <PageHeader hero>
      <TextHeading variant="subtitle" color="secondary">Knowing our customers</TextHeading>
      <TextHeading variant="xl" block>Responsible sourcing</TextHeading>
    </PageHeader>
    <SubMenuMobile/>
    <PageGrid sidebar sharetools>
      <PageSide>
        <SideNav/>
        <KeyUpcomingDates/>
        <CardDownload title="Corporate Responsibility 2018/2019" shape="rectangle"/>
      </PageSide>
      <PageMain>
        <ShareLinksArticle desktop></ShareLinksArticle>
        <HeroImage image="cr-fishing.jpg"></HeroImage>
        <TextProse>
          <p>We know that our customers want their fish to be responsibly sourced. Fishing and farming will always have some impact on the environment, but we aim to source fish which is caught or farmed using methods which are the least detrimental to the marine environment, provide equitable working conditions and stable incomes to those employed within them.</p>
          <p>Morrisons Fish and Seafood Sourcing Policy provide the detail to our suppliers of our wild capture and aquaculture sourcing requirements.</p>
          <p>Each species that we stock has to meet a set of conditions before it goes into our stores. Important sustainability criteria, such as stock levels, fisheries management and where and how the fish is caught are properly considered as part of our rigorous “decision tree” process.</p>
          <blockquote>
            <p>Each species that we stock has to meet a set of conditions before it goes into our stores.</p>
          </blockquote>
          <p>Included within our policy are commitments to the schemes, initiatives or programmes which inform and support our work to allow us to source from responsible supply chains.</p>
          <p>Where issues are identified in either existing or new supply chains we work hard with our suppliers to understand the challenges being faced and agree action plans to address them, even if they might take many years to deliver.</p>
          <p>More details of the challenges that we have identified and what we are doing to address them can be found in our Ocean Disclosure Project.</p>
        </TextProse>
        <PageQuotes
          image="logos/logo-sfp.png"
          quote="Morrisons are signatories to the Sustainable Fisheries Partnership’s Ocean Disclosure Project"
          button="Visit the SFP website"
        ></PageQuotes>
        <TextProse>
          <p>Making seafood sourcing simple.</p>
          <p>We understand that some of the fisheries management concepts aren't easy to explain. Rather than providing you with lots of words The Pew Charitable Trusts has developed a Visual Glossary of Ocean Terminology which we hope will give you a better understanding and can be found here.</p>
          <BaseButton href="#" variant="primary" class="prose-button">Visit the Pew website</BaseButton>
        </TextProse>
        <ShareLinksArticle mobile></ShareLinksArticle>
      </PageMain>
    </PageGrid>
    <FooterInfo></FooterInfo>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import FooterInfo from '../components/FooterInfo.vue'
import TextProse from '../elements/TextProse.vue'
import PageMain from '../elements/PageMain.vue'
import HeroImage from '../components/HeroImage.vue'
import ShareLinksArticle from '../components/ShareLinksArticle.vue'
import CardDownload from '../components/CardDownload.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import SubMenuMobile from '../components/SubMenuMobile.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
import BaseButton from '../elements/BaseButton.vue'
import PageQuotes from '../components/PageQuotes.vue'
export default {
  name: 'SeafoodResponsibleSourcing',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    SubMenuMobile,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    CardDownload,
    ShareLinksArticle,
    HeroImage,
    PageMain,
    TextProse,
    FooterInfo,
    TheFooter,
    BaseButton,
    PageQuotes
  }
}
</script>

<style lang="postcss">
.prose a.prose-button {
  @apply text-white font-normal text-base;
}
.prose a.prose-button:hover {
  @apply text-white font-normal;
}
</style>
